import styles from './machine-info.module.scss';
import { TextField } from '@frontend-workspace/react-shared-lib';
import { IMachineInfo } from '../../_models/machine-info';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface MachineInfoProps {
  machineInfo: IMachineInfo
}

export function MachineInfo(props: MachineInfoProps) {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-row flex-wrap">
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.windowsUsername")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.userName || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.domainName")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.domainName || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.machineName")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.machineName || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.localFolder")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.localFolder || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.systemSerialNumber")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.sysVolId || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.systemDiskSignature")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.sysDiskId || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.operatingSystem")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.OS || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("machineInfo.architecture")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.architecture || ''}
        />
      </div>
      <div className='me-3 mb-3'>
        <TextField
          fullWidth
          label={t("standard.virtualMachine")}
          sx={{ width: '320px' }}
          disabled
          value={props.machineInfo?.isVirtualMachine || ''}
        />
      </div>
      <div className="d-flex flex-column">
        <label>{t("standard.macAddresses")}</label>
        {props.machineInfo.macAdresses?.length === 0 ?
          <div className='me-3 mb-3'>
            <TextField
              fullWidth
              sx={{ width: '320px' }}
              disabled
              value={props.machineInfo?.macAdresses || ''}
            />
          </div> :
          <div>
            {props.machineInfo?.macAdresses?.map(address =>
              <TextField
                fullWidth
                sx={{ width: '320px' }}
                disabled
                value={address}
                key={address}
                className='me-3 mb-3'
              />
            )}
          </div>
        }
      </div>
    </div>
  );
}

export default MachineInfo;